export default __webpack_public_path__ + "66a8cd83844e022ea75f98d48cb2c7da.png";